module.exports = __webpack_public_path__ + "img/jared-rice-8w7b4SdhOgw-unsplash.90774394.jpg";